import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=36fc7ca4&scoped=true"
import script from "./LazyImage.vue?vue&type=script&lang=ts"
export * from "./LazyImage.vue?vue&type=script&lang=ts"
import style0 from "./LazyImage.vue?vue&type=style&index=0&id=36fc7ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fc7ca4",
  null
  
)

export default component.exports